<template>
    <el-dialog v-if="videodialogVisible" top="20vh" :title="name" custom-class="v-dialog" :visible.sync="videodialogVisible"
        append-to-body>
        <swiper ref="swiper" :options="swiperOption" class="myPlayerMonitor">
            <swiper-slide v-for="(item, index) in list" :key="item.id">
                <video :id="'myPlayer' + item.Value" style="width:100%;height:auto;margin-top: 0px;" :index="index" controls
                    playsInline webkit-playsinline autoplay>
                    <source :src="item.Data" type="rtmp/flv" />
                </video>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
    </el-dialog>
</template>

<script>
import PubSub from 'pubsub-js'


export default {
    name: 'PopVideo',
    data() {
        return {
            videodialogVisible: false,
            name: '',
            list: [
                {
                    "Name": "d96b860a-ff98-42a0-b16c-88f661a5722b",
                    "Value": "1",
                    "Data": "https://open.ys7.com/v3/openlive/BA4483679_1_2.m3u8?expire=1725521137&id=621365741697892352&t=303497d4a1172b3b5b8f74ee5aa7636167a9ac74a168ca33b708dbd2db7f96c9&ev=100"
                },
                {
                    "Name": "d96b860a-ff98-42a0-b16c-88f661a5722b",
                    "Value": "2",
                    "Data": "https://open.ys7.com/v3/openlive/BA4483679_1_2.m3u8?expire=1725521137&id=621365741697892352&t=303497d4a1172b3b5b8f74ee5aa7636167a9ac74a168ca33b708dbd2db7f96c9&ev=100"
                },
                {
                    "Name": "d96b860a-ff98-42a0-b16c-88f661a5722b",
                    "Value": "3",
                    "Data": "https://open.ys7.com/v3/openlive/BA4483679_1_2.m3u8?expire=1725521137&id=621365741697892352&t=303497d4a1172b3b5b8f74ee5aa7636167a9ac74a168ca33b708dbd2db7f96c9&ev=100"
                }
            ],
            swiperOption: {
                initialSlide: 0,
                speed: 1000,
                loop: false,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }
        }
    },
    mounted() {
        PubSub.subscribe('video', (msg, data) => {
            console.log(msg);
            this.name = data.name
            this.videodialogVisible = data.visible
            this.list = data.list
            this.initVideo()
        })
    },
    methods: {
        initVideo() {
            let interval = setTimeout(() => {
                if (this.list.length > 0) {
                    for (let index = 0; index < this.list.length; index++) {
                        const element = this.list[index];
                        let realRef = 'myPlayer' + element.Value;
                        if (!element.cameraIndexCode) {
                            new EZuikit.EZUIPlayer(realRef);
                        }
                    }
                }
                clearTimeout(interval);
            }, 500)
        }
    }
}
</script>

<style></style>